// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/propeller-effects.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/propeller-effects/propeller-effects.js';

mount([g0]);
